import React from "react";

import PlaylistItem from "./playlist-item";

type Props = {
  playlists: Playlists;
  isLoading: boolean;
};

const PlaylistSlider: React.FC<Props> = props => {
  const playlists = props.playlists || [];

  return (
    <div className="flex space-x-3 overflow-x-auto flex-nowrap scrolling-wrapper">
      <div className="flex-shrink-0 w-px"></div>

      {playlists.map(playlist => (
        <div className="flex-grow-0 flex-shrink-0 w-28 sm:w-32" key={playlist.id}>
          <PlaylistItem playlist={playlist} />
        </div>
      ))}

      {props.isLoading &&
        Array.from(Array(5).keys()).map(id => (
          <div className="flex-grow-0 flex-shrink-0 w-28 sm:w-32" key={id}>
            <div className="w-full rounded-lg ">
              <div className="relative flex flex-col justify-end w-full bg-gray-300 rounded-lg h-28 sm:h-32 animate-pulse" />

              <div className="px-2 py-2">
                <p className="h-3 bg-gray-300 rounded-lg animate-pulse" />
                <p className="h-2 mt-1 bg-gray-300 rounded-lg animate-pulse" />
              </div>
            </div>
          </div>
        ))}

      <div className="flex-shrink-0 w-px"></div>
    </div>
  );
};

export default PlaylistSlider;
